import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCalendarRoute: InvariantJiraRoute = {
	name: 'classic-business-calendar',
	path: '/jira/core/projects/:projectKey/calendar',
	exact: true,
};
